import { call, put, select, takeLatest } from "redux-saga/effects";
import api from "../../utils/api-helper/api";

import { toast } from "react-toastify";
import { createCouponFail, createCouponSuccess, deleteCouponFail, deleteCouponSuccess, getCouponsFail, getCouponsSuccess } from "../actions";
import { CreateCouponRequestAction, DeleteCouponRequestAction } from "../types";

// for admin
function* getCouponsSaga() {
    try {
        //@ts-ignore
        const res = yield api.get("/coupons");
        yield put(getCouponsSuccess(res.data.payload));
    } catch (error) {
        yield put(getCouponsFail(error));
    }
}

function* createCouponSaga(action: CreateCouponRequestAction) {
    const { coupon } = action.payload;

    try {
        //@ts-ignore
        const res = yield api.put("/coupons", coupon);
        if (res.data.status === 409) {
            toast.error(res?.data?.message || "Unable to create coupon", {
                hideProgressBar: true,
                position: "top-center",
                theme: "colored",
            });
        }
        yield put(createCouponSuccess(res));
        yield call(getCouponsSaga);
    } catch (error) {
        yield put(createCouponFail(error));
    }
}

function* deleteCouponSaga(action: DeleteCouponRequestAction) {
    const couponId = action.payload;
    try {
        //@ts-ignore
        const res = yield api.delete(`/coupons/${couponId}`);
        if (res.status === 200) {
            yield put(deleteCouponSuccess());
            yield call(getCouponsSaga);
        }
    } catch (error) {
        yield put(deleteCouponFail(error));
    }
}

function* saveState() {
    //@ts-ignore
    const state = yield select();
    yield localStorage.setItem("initState", JSON.stringify(state));
}

const sagaWatcher = [takeLatest("GET_COUPONS_REQUEST", getCouponsSaga), takeLatest("CREATE_COUPON_REQUEST", createCouponSaga), takeLatest("DELETE_COUPON_REQUEST", deleteCouponSaga), takeLatest("*", saveState)];

export default sagaWatcher;
